// Kaikki sivuston tekstit yhdessä paikassa. Helppo muokata myöhemmin.
export const site = {
  name: "By Milja V",
  email: "bymiljav@outlook.com",
  businessId: "3584047-2",
  instagram: { handle: "@bymiljav", url: "https://www.instagram.com/bymiljav/" },
  area: "Pirkanmaa ja lähialueet, tarvittaessa myös muualla.",

  nav: [
    { label: "Palvelut", id: "palvelut" },
    { label: "Näin edetään", id: "prosessi" },
    { label: "Minusta", id: "minusta" },
    { label: "UKK", id: "ukk" },
  ],
  navCta: "Ota yhteyttä",

  hero: {
    eyebrow: "Sisällöntuotanto · Pirkanmaa",
    titleLines: ["Sosiaalinen media", "haltuun", "ilman stressiä."],
    subtitle:
      "Sisällöntuotantoa, kuvausta ja selkeitä suunnitelmia yrityksille, jotka haluavat näkyä somessa omalla tyylillään.",
    primaryCta: "Ota yhteyttä",
    secondaryCta: "Katso palvelut",
    trust: ["Sisällöntuotanto", "Strategia", "Kuvaus"],
    imageAlt: "Milja Vuorinen hymyilee kameralle",
  },

  marquee: ["Sisällöntuotanto", "Strategia", "Kuvaus", "Editointi", "Sparraus"],

  services: {
    chapter: "01",
    label: "Palvelut",
    title: "Selkeää someapua",
    items: [
      {
        slug: "kuvaus",
        title: "Kuvaus",
        text: "Valokuvat ja videot, joissa yrityksesi palvelut ja tuotteet näyttävät siltä miltä niiden kuuluukin.",
      },
      {
        slug: "editointi",
        title: "Editointi",
        text: "Viimeistellyt reelsit, kuvat ja leikkaukset julkaisuvalmiina.",
      },
      {
        slug: "sisaltosuunnittelu",
        title: "Sisältösuunnittelu",
        text: "Julkaisukalenterit ja sisältösuunnitelmat, jotta tiedät aina mitä julkaiset ja miksi.",
      },
      {
        slug: "sparraus",
        title: "Somen sparraus ja työkalut",
        text: "Matalan kynnyksen apua siihen, miten some rakennetaan niin että se tuottaa yritykselle aidosti lisäarvoa. Tarvittaessa myös tilien perustaminen ja käyttöönotto.",
      },
    ],
    tailorNote:
      "Jokainen kokonaisuus räätälöidään yrityksesi tarpeen mukaan. Kerro tilanteesi, niin mietitään yhdessä mikä toimii.",
  },

  process: {
    chapter: "02",
    label: "Prosessi",
    title: "Näin edetään",
    steps: [
      {
        n: "01",
        title: "Yhteydenotto",
        text: "Kerro lyhyesti yrityksestäsi ja siitä mikä somessa mietityttää.",
      },
      {
        n: "02",
        title: "Kartoitus",
        text: "Käydään läpi tavoitteet, kohderyhmä ja nykytilanne.",
      },
      {
        n: "03",
        title: "Toteutus",
        text: "Kuvaukset, editointi ja sisällöt sovitussa aikataulussa.",
      },
      {
        n: "04",
        title: "Jatko",
        text: "Julkaisusuunnitelma ja sparraus, jotta näkyvyys kasvaa myös jatkossa.",
      },
    ],
  },

  about: {
    chapter: "03",
    label: "Minusta",
    title: "Hei, olen Milja",
    paragraphs: [
      "By Milja V on kangasalalaisen Milja Vuorisen perustama yritys, joka tarjoaa sosiaalisen median sisällöntuotantoapua yrityksille. Otan kuvia ja kuvaan videoita yritysten palveluista ja tuotteista, juuri sitä mitä asiakas tarvitsee. Autan myös sosiaalisen median työkalujen, kuten tilien ja sisältösuunnitelmien, luomisessa.",
      "Uskon siihen, että somen ei tarvitse olla monimutkaista. Tärkeintä on, että se näyttää yritykseltäsi ja tuo sinulle oikeita asiakkaita.",
    ],
    quote: "Somen ei tarvitse olla monimutkaista.",
    signature: "Milja",
    imageAlt: "Milja Vuorinen, By Milja V:n perustaja",
  },

  media: {
    chapter: "04",
    label: "Mediassa",
    headline: "By Milja V – Sosiaalisen median uusi B2B-tuki löytyy Ruutanasta",
    source: "Business Kangasala",
    date: "12.8.2026",
    url: "https://www.businesskangasala.fi/blogi-ja-yritystarina/by-milja-v/",
    linkText: "Lue artikkeli Business Kangasalan sivustolla",
    quote: "Milja haluaa auttaa osaamisellaan muita, se tuntuu hänestä hyvältä.",
  },

  some: {
    chapter: "05",
    label: "Some",
    title: "Kurkkaa, miltä yhteistyö näyttää",
    lead: "Tuoreimmat työt ja kulissien kuulumiset löydät Instagramistani. Tule seuraamaan!",
    followCta: "Seuraa Instagramissa",
    emptyTitle: "@bymiljav",
    emptyText: "Kaikki tuoreimmat julkaisut ja arjen kuulumiset löydät suoraan Instagram-profiilista.",
    // Pystyvideot (9:16). Oikeat videot kansiossa /public/videos.
    reels: [
      { poster: "/videos/reel-poster-1.jpg", video: "/videos/reel-1.mp4", caption: "" },
      { poster: "/videos/reel-poster-2.jpg", video: "/videos/reel-2.mp4", caption: "" },
      { poster: "/videos/reel-poster-3.jpg", video: "/videos/reel-3.mp4", caption: "" },
      { poster: "/videos/reel-poster-4.jpg", video: "/videos/reel-4.mp4", caption: "" },
      { poster: "/videos/reel-poster-5.jpg", video: "/videos/reel-5.mp4", caption: "" },
    ],
  },

  faq: {
    chapter: "06",
    label: "UKK",
    title: "Usein kysytyt kysymykset",
    lead: "Somemaailma voi tuntua hämmentävältä. Tässä vastaukset kysymyksiin, joita kuulen useimmin.",
    items: [
      {
        q: "En ole tehnyt somea yritykselle koskaan. Mistä kannattaisi aloittaa?",
        a: "Siitä, että laitat minulle viestiä. Käydään yhdessä läpi missä mennään nyt ja mitä haluat saavuttaa, ja teen sinulle selkeän suunnitelman. Jos tilejä ei vielä ole, voimme perustaa myös ne yhdessä.",
      },
      {
        q: "Pitääkö minun osata somea tai kuvausta etukäteen?",
        a: "Ei tarvitse osata mitään. Minä hoidan kuvaukset, editoinnin ja suunnittelun, sinä kerrot yrityksestäsi omin sanoin. Opastan sinua kaikessa alusta loppuun asti.",
      },
      {
        q: "Entä jos en ole varma, mitä palvelua tarvitsen?",
        a: "Moni aloittaa juuri tästä. Valitse lomakkeessa ”En ole varma” ja kerro mikä mietityttää. Mietitään yhdessä mikä toimisi teidän arjessa.",
      },
      {
        q: "Teetkö myös kertaluonteisia kuvauksia?",
        a: "Teen. Yhteistyö voi olla yksi kuvauspäivä, sisältöpaketti tai jatkuvaa sparrausta. Ei turhia paketteja, vaan juuri se mistä sinulle on oikeasti hyötyä.",
      },
      {
        q: "Millä alueella toimit?",
        a: "Kotipaikkani on Kangasalla ja teen töitä pääasiassa Pirkanmaan yritysten kanssa. Tarvittaessa tulen mielelläni myös pidemmälle.",
      },
      {
        q: "Kuinka nopeasti yhteistyö lähtee käyntiin?",
        a: "Vastaan yhteydenottoihin yleensä saman päivän aikana. Sen jälkeen sovitaan kartoitus, ja kuvaukset tehdään sovitussa aikataulussa.",
      },
    ],
  },

  contact: {
    chapter: "07",
    label: "Yhteys",
    title: "Otetaan yhdessä some haltuun",
    lead: "Kerro tilanteestasi, niin vastaan yleensä saman päivän aikana.",
    fields: {
      name: "Nimi",
      company: "Yritys",
      email: "Sähköposti",
      phone: "Puhelin",
      topics: "Millaista apua kaipaat?",
      message: "Viesti",
    },
    placeholders: {
      name: "Etunimi Sukunimi",
      company: "Yrityksen nimi (valinnainen)",
      email: "nimi@yritys.fi",
      phone: "040 123 4567 (valinnainen)",
      message: "Kerro lyhyesti yrityksestäsi ja siitä, missä some kanssasi kaipaisi apua…",
    },
    topicOptions: ["Kuvaus", "Editointi", "Sisältösuunnittelu", "Sparraus", "En ole varma"],
    errors: {
      name: "Kirjoita nimesi.",
      emailRequired: "Kirjoita sähköpostiosoitteesi.",
      emailInvalid: "Tarkista sähköpostiosoitteen muoto.",
      message: "Kerro lyhyesti, millaista apua tarvitset.",
      sendFailed: "Viestin lähetys ei onnistunut. Yritä hetken kuluttua uudelleen tai lähetä sähköpostia suoraan osoitteeseen bymiljav@outlook.com.",
    },
    submit: "Lähetä viesti",
    sending: "Lähetetään…",
    successTitle: "Kiitos viestistäsi!",
    successText: "Viestisi on lähtenyt matkaan. Vastaan yleensä saman päivän aikana.",
    successAgain: "Lähetä toinen viesti",
    directTitle: "Suorat yhteystiedot",
  },

  footer: {
    tagline: "Matalan kynnyksen someapu yrityksille.",
    copyright: "© 2026 By Milja V",
    businessIdLabel: "Y-tunnus:",
    privacy: "Tietosuojaseloste",
    creditLabel: "Verkkosivut:",
    creditName: "MyyntiDrive",
    creditUrl: "https://myyntidrive.fi/?utm_source=bymiljav&utm_medium=footer",
  },

  privacy: {
    title: "Tietosuojaseloste",
    updated: "Päivitetty 1.7.2026",
    back: "Takaisin etusivulle",
    sections: [
      {
        heading: "Rekisterinpitäjä",
        paragraphs: [
          "By Milja V / Milja Vuorinen, Kangasala. Y-tunnus: 3584047-2. Yhteydenotot tietosuoja-asioissa: bymiljav@outlook.com.",
        ],
      },
      {
        heading: "Mitä tietoja kerätään",
        paragraphs: [
          "Sivuston yhteydenottolomakkeella kerätään tiedot, jotka itse täytät: nimi, yritys, sähköpostiosoite, puhelinnumero, valitsemasi avuntarpeen aiheet sekä vapaamuotoinen viesti.",
          "Sivusto ei käytä evästeitä eikä seurantaan tarkoitettua analytiikkaa.",
        ],
      },
      {
        heading: "Mihin tietoja käytetään",
        paragraphs: [
          "Tietoja käytetään ainoastaan yhteydenottoosi vastaamiseen ja mahdollisen yhteistyön valmisteluun. Lomakkeen tiedot välitetään sähköpostitse osoitteeseen bymiljav@outlook.com.",
        ],
      },
      {
        heading: "Tietojen säilytys ja luovutus",
        paragraphs: [
          "Tietoja säilytetään vain niin kauan kuin yhteydenoton käsittely ja mahdollinen asiakkuus sitä edellyttävät. Tietoja ei luovuteta kolmansille osapuolille eikä siirretä EU:n ulkopuolelle.",
        ],
      },
      {
        heading: "Oikeutesi",
        paragraphs: [
          "Sinulla on oikeus tarkastaa sinusta tallennetut tiedot, pyytää niiden oikaisua tai poistoa sekä tehdä valitus tietosuojavaltuutetun toimistoon. Ota yhteyttä: bymiljav@outlook.com.",
        ],
      },
    ],
  },
};
